import React from 'react';
import ReactModal from 'react-modal';
import './Modal.css';

interface ModalProps {
    testId: string;
    width: number;
    height: number;
    isOpen: boolean;
    onRequestClose: () => void;
    onAfterOpen?: () => void;
    loading?: boolean;
}

const Modal: React.FC<ModalProps> = ({testId, children, width, height, onRequestClose, onAfterOpen, loading, isOpen = false }) => (
        <ReactModal testId={`${testId}`} onAfterOpen={onAfterOpen} closeTimeoutMS={300} onRequestClose={onRequestClose} isOpen={isOpen} style={{
        content: { width: `${width}px`, minHeight: `${height}px`, padding: '30px', top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)' },
        overlay: { background: 'rgba(0, 0, 0, 0.5)' }
    }}>
        { !loading ? children : <p>Loading...</p>}
    </ReactModal>
);

export default Modal;
